import { useMutation } from '@tanstack/react-query';
import { Eye } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { useMasterSession } from '@/features/auth/hooks/useSession';
import { api } from '@/shared/api';

import { leaveFor } from './leaveFor';

/**
 * Shown while a platform owner is viewing the app as this master (the API sets
 * `impersonating` on /auth/me). Whatever they do here is logged against them;
 * the button hands the session back to the console.
 */
export const ImpersonationBanner = () => {
  const { t } = useTranslation('app');
  const { user } = useMasterSession();
  const stop = useMutation({
    mutationFn: () => api.post<{ redirectUrl: string }>('/auth/impersonation/stop'),
    onSuccess: ({ redirectUrl }) => leaveFor(redirectUrl),
  });

  if (!user?.impersonating) return null;

  return (
    <div
      role="status"
      className="flex flex-wrap items-center justify-center gap-3 bg-amber-100 px-4 py-2 text-sm font-semibold text-amber-900"
    >
      <Eye size={16} aria-hidden="true" />
      <span>{t('impersonation.banner', { name: user.name })}</span>
      <button
        type="button"
        onClick={() => stop.mutate()}
        disabled={stop.isPending}
        className="rounded-lg bg-amber-900 px-3 py-1 text-xs font-bold text-white hover:bg-amber-800"
      >
        {t('impersonation.stop')}
      </button>
    </div>
  );
};
